import { render } from "./SidebarMenu.vue?vue&type=template&id=231aa55c"
import script from "./SidebarMenu.vue?vue&type=script&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/learnbil/public_html/learnbilly.com/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__